import { Button, Flex, Text, useClipboard } from "@chakra-ui/react";
import { useState } from "react";
import { IoCopyOutline, IoCheckmarkDoneSharp } from "react-icons/io5";
import { Link } from "react-router-dom";

const RequestId = ({ requestId, isLink }) => {
  const [isCopied, setIsCopied] = useState(false);
  const { onCopy } = useClipboard(requestId);

  const handleCopy = () => {
    onCopy();
    setIsCopied(true);
    // Reset the copied state after a delay
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <Flex alignItems="center">
      {isLink ? (
        <Link to={`/requests/${requestId}`}>
          {requestId.slice(0, 8)}...{requestId.slice(-6)}
        </Link>
      ) : (
        <Text title={requestId} color="#fff" fontWeight="bold">
          {requestId.slice(0, 8)}...{requestId.slice(-6)}
        </Text>
      )}
      <Button onClick={handleCopy} padding={0} colorScheme="gray" ml={2}>
        {isCopied ? <IoCheckmarkDoneSharp /> : <IoCopyOutline />}
      </Button>
    </Flex>
  );
};

export default RequestId;
